import React from 'react';
import { motion } from 'framer-motion';
import { costBreakdown } from '@/lib/campaign';

const rupees = (paise) => `₹${(paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const EXAMPLE = costBreakdown(100000); // ₹1,000 of ad spend

/** How ad spend is charged (shown on the Wallet and Pricing pages). */
export default function PricingExplainer({ className = '' }) {
  return (
    <motion.section initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}
      className={`neo-card !bg-butter p-6 ${className}`} aria-labelledby="pricing-title">
      <h2 id="pricing-title" className="text-lg font-extrabold font-heading mb-1">How pricing works</h2>
      <p className="text-xs mb-4">An example for ₹1,000 of ads:</p>
      <dl className="space-y-2 text-sm">
        <div className="flex justify-between"><dt>Ad spend (goes to Meta)</dt><dd className="font-semibold">{rupees(EXAMPLE.spend)}</dd></div>
        <div className="flex justify-between"><dt>Our fee (15%)</dt><dd>{rupees(EXAMPLE.fee)}</dd></div>
        <div className="flex justify-between"><dt>GST (18% of the fee)</dt><dd>{rupees(EXAMPLE.gst)}</dd></div>
        <div className="flex justify-between font-bold border-t-2 border-dashed border-ink pt-2"><dt>Held from your wallet</dt><dd>{rupees(EXAMPLE.total)}</dd></div>
      </dl>
      <p className="text-xs mt-4 leading-relaxed">If Meta spends less, you&apos;re charged only for what it spent (plus the fee on that), and the rest comes back. Minimum ad budget ₹1,000, minimum top-up ₹500.</p>
    </motion.section>
  );
}
